import { faPen, faTrash, faQuestionCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Auth/AuthContext'
import { Col, Row, Table, Button, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading } from '../Library';
import { AlertModalContext } from '../Library/AlertModalContext'
import { NotifyContext } from '../Library/Notify'
import { wtc53109 } from '../Network/Config'


import "./SpareManageDevice.css"
import axios from 'axios'

function SpareMangeDevice(props) {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.listspare
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [companyName, setCompanyName] = useState("")
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [listSpare, setListSpare] = useState([])
    const [filter, setFilter] = useState("")
    const [isError, setError] = useState(false);
    const [listFilter, setListFilter] = useState([])

    useEffect( async ()=>{
        console.log(props.company)
        try {
            setIsLoading(true)
            const formData = new FormData();
            formData.append('company_id', props.company);
            const responseData = await axios.post(wtc53109+'/spare_part/api/v1/list_spare', formData);
            setListSpare(responseData.data.data.list);
            setIsLoading(false)
        } catch (e) {
            console.error(e);
            setIsLoading(false)
        }
        search()
    }, [10, filter,props])

    const search = () => {
        setListFilter([])
        listSpare.filter((item, index)=>{
                if(
                   item.part_id
                   .toLowerCase()
                   .includes(filter.toLowerCase()) ||
                   item.part_name
                   .toLowerCase()
                   .includes(filter.toLowerCase()) ||
                   item.price
                   .toLowerCase()
                   .includes(filter.toLowerCase()) ||
                   item.qty
                   .toLowerCase()
                   .includes(filter.toLowerCase())
                ){
                    setListFilter(newArray => [...newArray, item])
                }
        })
    }

    const formattedDate = (date) => {
        const dateFormatted = dayjs(date).format("D MMM YYYY - H:mm")
        return dateFormatted
    }

    const deleteSpare =  (id)  =>{
        console.log(id)
        alertModal.setTitle(lang.delete_spare)
        alertModal.setDescription(lang.sure_to_delete)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: async () =>{ 
                    alertModal.setIsShow(false)
                    setIsLoading(true)
                    const formData = new FormData();
                    formData.append('part_id', id);
                    await axios.post(wtc53109+'/spare_part/api/v1/delete_spare', formData);
                    //history.go(0)
                    setIsLoading(false)
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        
        alertModal.setIsShow(true)
    }

    const callList = () =>{
        if(filter == ''){
            return(
                listSpare.map((item, key) =>
                                    <ListSpareItem
                                    key={key}
                                    id={item.part_id}
                                    name={item.part_name}
                                    price={item.price}
                                    qty={item.qty}
                                    onEditClick={()=>history.push("/managedevice/edit/"+item.part_id)}
                                    onDeleteClick={()=>deleteSpare(item.part_id)}
                                    />
                                )
            )
        } else {
            return(
                listFilter.map((item, key) =>
                                    <ListSpareItem
                                    key={key}
                                    id={item.part_id}
                                    name={item.part_name}
                                    price={item.price}
                                    qty={item.qty}
                                    onEditClick={()=>history.push("/managedevice/edit/"+item.part_id)}
                                    onDeleteClick={()=>deleteSpare(item.part_id)}
                                    />
                                )
            )
        }
    }

    const ListSpareItem = ({ id, name, price, qty, onEditClick, onDeleteClick }) => {
        return(
            <tr>
                <td></td>
                <td>{id}</td>
                <td>{name}</td>
                <td>{price}</td>
                <td>{qty}</td>
                <td>
                    <div className="action-container">
                        <Button size="sm"
                        onClick={onEditClick}>
                            <FontAwesomeIcon icon={faPen}/>
                        </Button>
                        <Button size="sm" variant="danger" style={{marginLeft: 10}}
                        onClick={onDeleteClick}>
                            <FontAwesomeIcon icon={faTrash}/>
                        </Button> 
                    </div>
                </td>
            </tr>
        )
    }

    return(
        <div id="spare-device">
            { isLoading ? <Loading/> : null }
            <div className="button-container">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div>
                    <Form.Group>
                        <Row>
                            <Col style={{display:'flex'}}>
                                <Form.Control
                                    style={{marginRight:'10px'}}
                                    placeholder={'ค้นหา'}
                                    value={filter}
                                    isInvalid={isError && !filter}
                                    onChange={(e)=>setFilter(e.target.value)}
                                />
                                {/*<Button onClick={()=>search()}>ค้นหา</Button>*/}
                            </Col>
                        </Row>
                    </Form.Group>
                    </div>
                    <div style={{justifyContent:'flex-end'}}>
                        <Button onClick={()=>history.push("/managedevice/create")}>เพิ่ม Device</Button>
                    </div>
                </div>
            </div>
            
            <div className='table-container'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{'Part ID'}</th>
                            <th>{'Part Name'}</th>
                            <th>{'Price'}</th>
                            <th>{'Quatity'}</th>
                            <th>{}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                             callList()   
                        }
                    </tbody>
                </Table>
            </div>
            {/*
            <TablePagination
            dataLength={Math.ceil(count / size)}
            currentPage={page}
            size={size}
            handlerPaginationClick={(page)=>setPage(page)}
            prevClick={()=>setPage(page - 1)}
            nextClick={()=>setPage(page + 1)}
            firstPageClick={(page)=>setPage(page)}
            lastPageClick={(page)=>setPage(page)}
            disabledPrev={page === 1}
            disabledNext={page === Math.ceil(count / size)}
            />
            */ }
        </div>
    )
}

export default SpareMangeDevice;
